module.exports = __webpack_public_path__ + "img/MES8Area_selection.64d9b0eb.png";